import React from "react";
import { Link } from "react-router-dom";
import "./Foreclosuresheader.css";

export default function Foreclosuresheader() {
  const base = process.env.PUBLIC_URL;

  return (
    <section
      className="fc-hero"
      role="banner"
      aria-label="Foreclosures hero banner"
    >
      {/* Background image (full width) */}
      <img
        className="fc-hero__bg"
        src={`${base}/(232).webp`}
        alt="Professional foreclosure cleanout team at work"
        loading="eager"
      />

      {/* Contrast overlay */}
      <div className="fc-hero__overlay" aria-hidden="true" />

      {/* Centered content */}
      <div className="fc-hero__content">
        <nav className="fc-hero__breadcrumb" aria-label="Breadcrumb">
          <Link to="/" className="fc-hero__breadcrumb-link">Home</Link>
          <span className="fc-hero__breadcrumb-sep" aria-hidden="true">›</span>
          <span className="fc-hero__breadcrumb-current">Foreclosure Cleanouts</span>
        </nav>

        <h1 className="fc-hero__title">Foreclosure Cleanouts</h1>
        <p className="fc-hero__subtitle">
          Reliable foreclosure property clearing services to restore order and value.
        </p>
      </div>

      {/* Premium depth touches */}
      <div className="fc-hero__vignette" aria-hidden="true" />
      <div className="fc-hero__grain" aria-hidden="true" />
    </section>
  );
}
